export default "__VITE_PUBLIC_ASSET__850755bd__"